import {PlayMode} from "html-living-framework";
import {Dict, EnumDict} from "../core/Reflection";
import {LevelNumber} from "./LevelModel";
import {Location} from "./Location";
import {CardNumber} from "./LocationCardType";
import {OnboardingStep} from "./OnboardingStep";

export const voOptionsOnboarding = {priority: 20};
export const voOptionsDirections = {priority: 10};
export const voOptionsButtons = {priority: 0};
export const voOptionsIdle = {priority: 0, mode: PlayMode.New};

export const voMatchKudos = [
    "patw_a01",
    "patw_a02",
    "patw_a03",
    "patw_a04",
    "patw_a05",
    "patw_a06",
    "patw_a07",
    "patw_a08",
    "patw_a09",
    "patw_a10",
    "patw_a11",
];

export const voPostcardCompleteKudos = [
    "patw_a04",
    "patw_a05",
    "patw_a06",
    "patw_a07",
    "patw_a08",
];

export const voOnboarding: Dict<OnboardingStep, string> = {
    [OnboardingStep.SwitchLocation]: "patw_o01",
    [OnboardingStep.SelectLocation]: "patw_o02",
    [OnboardingStep.ChooseTile]: "patw_o03",
    [OnboardingStep.SavePrint]: "patw_o04",
    [OnboardingStep.GoHome]: "patw_o05",
};

export interface LocationVOData {
    prefix: string;
    name: string;
    from: number;
    idles: Array<number | string>;
    postcards: PostcardVOData[];
}

export interface PostcardVOData {
    name: number;
    tiles: Array<number | string>;
    facts: Array<number | string>;
}

export const voLocation: EnumDict<Location, LocationVOData> = {
    [Location.Beijing]: {
        name: "patw_ui21",
        prefix: "patw_gb",
        from: 3,
        idles: [18, 19],
        postcards: [
            {name: 1, tiles: [4, 5, 6, 7, -1, 8, 9, 10], facts: [20, 21, 22, 23, -1, 24, 25, 26]},
            {name: 2, tiles: [11, 12, -1, 13, 14, 15, 16, 17], facts: [33, 27, -1, 28, 29, 30, 31, 32]},
        ],
    },
    [Location.Cusco]: {
        name: "patw_ui22",
        prefix: "patw_gc",
        from: 3,
        idles: [18, 19],
        postcards: [
            {name: 1, tiles: [4, 5, 6, 7, 8, -1, 9, 10], facts: [20, 21, 22, 23, 24, -1, 25, 26]},
            {name: 2, tiles: [13, 12, 17, -1, 14, 16, 15, 11], facts: [30, 29, 28, -1, 31, 33, 32, 27]},
        ],
    },
    [Location.Nairobi]: {
        name: "patw_ui23",
        prefix: "patw_gn",
        from: 3,
        idles: [18, 19],
        postcards: [
            {name: 1, tiles: [8, 5, 9, 4, 7, 6, 10, -1], facts: ["26b", 23, 21, 22, 25, 24, 20, -1]},
            {name: 2, tiles: [17, 12, -1, 14, 11, 13, 16, 15], facts: [33, 28, -1, 30, 27, 29, 32, 31]},
        ],
    },
    [Location.Munich]: {
        name: "patw_ui24",
        prefix: "patw_gm",
        from: 3,
        idles: [18, 19],
        postcards: [
            {name: 1, tiles: [4, 5, 6, 9, 8, 7, -1, 10], facts: [20, 21, 22, 25, 24, 23, -1, 26]},
            {name: 2, tiles: [14, 13, -1, 12, 11, 17, 15, 16], facts: [30, 29, -1, 28, 27, 33, 31, 32]},
        ],
    },
    [Location.Tokyo]: {
        name: "patw_ui25",
        prefix: "patw_gj",
        from: 3,
        idles: [18, 19],
        postcards: [
            {name: 1, tiles: [5, 4, -1, 6, 7, 8, 10, 9], facts: [21, 20, -1, 22, 23, 24, 26, 25]},
            {name: 2, tiles: [-1, "17b", 15, 11, 12, 13, 14, 16], facts: [-1, 33, 31, 27, 28, 29, 30, 32]},
        ],
    },
    [Location.Rio]: {
        name: "patw_ui26",
        prefix: "patw_gr",
        from: 3,
        idles: [18, 19],
        postcards: [
            {name: 1, tiles: [4, 5, -1, 6, 7, 8, 9, 10], facts: [20, 21, -1, 22, 23, 24, 25, 26]},
            {name: 2, tiles: [17, 11, 12, 13, 14, 16, 15, -1], facts: [29, 28, 31, 27, 30, 33, 32, -1]},
        ],
    },
};

export function getLocationTileVO(location: Location, level: LevelNumber, tile: CardNumber) {
    return getLocationVO("tiles", location, level, tile);
}

export function getLocationFactVO(location: Location, level: LevelNumber, tile: CardNumber) {
    return getLocationVO("facts", location, level, tile);
}

export function getLocationIdleVO(location: Location) {
    const data = voLocation[location];
    return data.idles.map((it) => `${data.prefix}${it}`);
}

export function getLocationNameVO(location: Location) {
    return voLocation[location].name;
}

export function getLocationPostcardVO(location: Location, level: LevelNumber) {
    const data = voLocation[location];
    return `${data.prefix}0${data.postcards[level - 1].name}`;
}

export function getLocationFromVO(location: Location) {
    const data = voLocation[location];
    return `${data.prefix}0${data.from}`;
}

function getLocationVO(array: "tiles" | "facts", location: Location, level: LevelNumber, tile: CardNumber) {
    const data = voLocation[location];
    let value = data.postcards[level - 1][array][tile - 1];
    if (typeof value === "number" && value < 0) {
        return undefined;
    }
    if (typeof value === "number" && value < 10) {
        value = "0" + value;
    }
    return `${data.prefix}${value}`;
}
